import { render, staticRenderFns } from "./TopPlaysCLient.vue?vue&type=template&id=19dba89c&scoped=true"
import script from "./TopPlaysCLient.vue?vue&type=script&lang=js"
export * from "./TopPlaysCLient.vue?vue&type=script&lang=js"
import style0 from "./TopPlaysCLient.vue?vue&type=style&index=0&id=19dba89c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dba89c",
  null
  
)

export default component.exports